import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

export const LinkTab = styled(NavLink)`
  display: flex !important;
  align-items: center !important;
  gap: 5px !important;
  height: 60px !important;
  text-decoration: none;
`
